"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFinalClaim = exports.finalClaimSchema = void 0;
var constants_1 = require("@hobt/constants");
var schema_validator_1 = require("@hobt/schema-validator");
var adjudication_calculation_1 = require("./adjudication-calculation");
var applicable_rate_1 = require("./applicable-rate");
var approval_1 = require("./approval");
var assessment_1 = require("./assessment");
var borrower_1 = require("./borrower");
var borrower_charge_1 = require("./borrower-charge");
var calculation_detail_1 = require("./calculation-detail");
var cash_receipt_1 = require("./cash-receipt");
var constants_2 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var document_access_control_entry_schema_1 = require("../common/document-access-control-entry-schema");
var financial_transaction_1 = require("./financial-transaction");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var loan_administration_1 = require("./loan-administration");
var loan_detail_1 = require("./loan-detail");
var mandatory_documentation_1 = require("./mandatory-documentation");
var other_adjustment_1 = require("./other-adjustment");
var pending_condition_1 = require("./pending-condition");
var profile_1 = require("./profile");
var property_1 = require("./property");
var response_1 = require("./response");
var remark_1 = require("./remark");
var suspense_condition_1 = require("./suspense-condition");
var validation_result_1 = require("./validation-result");
exports.finalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'cmhcLoanAccountNumber',
        'claimTypeIndicator',
        'documentAccessControlEntry',
        'exceptionToListingFlag',
        'newInternalAttachmentFlag',
        'newInternalCommentFlag',
        'newExternalAttachmentFlag',
        'newExternalCommentFlag',
        'partialPaymentReceivedFlag',
        'recordCreatedTimestamp',
        'recordCreatedUserID',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'rentalIncomeReceivedFlag',
        'sequenceNumber',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with a length of 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with a length of 5 characters',
        },
        claimBusinessID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_2.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListingFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        newInternalAttachmentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newInternalCommentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newExternalAttachmentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newExternalCommentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        partialPaymentReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        rentalIncomeReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        sequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        adjudicationCalculation: adjudication_calculation_1.adjudicationCalculationSchema,
        applicableRate: applicable_rate_1.applicableRateSchema,
        approval: {
            type: ['object', 'null'],
            items: approval_1.approvalSchema,
        },
        assessment: assessment_1.assessmentSchema,
        borrowers: {
            type: ['array', 'null'],
            items: borrower_1.borrowerExtendedSchema,
        },
        borrowerCharges: {
            type: ['array', 'null'],
            items: borrower_charge_1.borrowerChargeExtendedSchema,
        },
        calculationDetail: calculation_detail_1.calculationDetailSchema,
        cashReceipts: {
            type: ['array', 'null'],
            items: cash_receipt_1.cashReceiptSchema,
        },
        defaultManagement: default_management_1.defaultManagementFinalClaimSchema,
        detail: detail_1.detailFinalClaimSchema,
        documentAccessControlEntry: document_access_control_entry_schema_1.documentAccessControlEntrySchema,
        financialTransaction: financial_transaction_1.financialTransactionSchema,
        indicator: indicator_1.indicatorFinalClaimSchema,
        lender: lender_1.finalLenderSchema,
        listings: {
            type: 'array',
            items: listing_1.finalListingExtendedSchema,
            minItems: 1,
            isAfterFirstListingDate: ['appraisalDate', 'comparativeMarketAnalysisDate', 'date'],
            isLessThanFirstListingAmount: ['revisedPriceAmount'],
        },
        loanAdministration: loan_administration_1.loanAdministrationSchema,
        loanDetail: loan_detail_1.loanDetailSchema,
        mandatoryDocumentation: mandatory_documentation_1.mandatoryDocumentationSchema,
        otherAdjustments: {
            type: ['array', 'null'],
            items: other_adjustment_1.otherAdjustmentExtendedSchema,
            hasValidOtherAdjustmentCounts: true,
        },
        pendingConditions: {
            type: ['array', 'null'],
            items: pending_condition_1.pendingConditionExtendedSchema,
        },
        profile: profile_1.profileSchema,
        property: property_1.finalPropertySchema,
        remark: remark_1.remarkSchema,
        response: response_1.responseSchema,
        suspenseConditions: {
            type: ['array', 'null'],
            items: suspense_condition_1.suspenseConditionSchema,
        },
        validationResult: validation_result_1.validationResultFinalClaimSchema,
    },
    allOf: [
        {
            if: {
                properties: {
                    indicator: {
                        properties: {
                            claimReceivedDate: {
                                type: 'string',
                                isNotEmpty: true,
                                format: 'date',
                            },
                        },
                    },
                    mandatoryDocumentation: {
                        properties: {
                            completeClaimReceivedDate: {
                                type: 'string',
                                isNotEmpty: true,
                                format: 'date',
                            },
                        },
                    },
                },
            },
            then: {
                properties: {
                    mandatoryDocumentation: {
                        type: ['object', 'null'],
                        properties: {
                            completeClaimReceivedDate: {
                                type: ['string', 'null'],
                                formatMinimum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_COMPLETE_CLAIM_RECEIVED_DATE),
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['detail', 'exceptionToListingFlag'],
                properties: {
                    exceptionToListingFlag: {
                        enum: [false, 'false'],
                    },
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                const: constants_2.ClaimTypeCode.DeficiencySale,
                            },
                        },
                    },
                },
            },
            then: {
                if: {
                    properties: {
                        detail: {
                            required: ['propertySoldByTypeCode'],
                            properties: {
                                propertySoldByTypeCode: {
                                    const: constants_2.PropertySoldBy.ByApprovedLender,
                                },
                            },
                        },
                    },
                },
                then: {
                    properties: {
                        listings: {
                            items: {
                                required: ['minimumAcceptableSalePriceAmount'],
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['detail', 'exceptionToListingFlag'],
                properties: {
                    exceptionToListingFlag: {
                        enum: [false, 'false'],
                    },
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                not: {
                                    enum: [constants_2.ClaimTypeCode.EnhancedClaimService, constants_2.ClaimTypeCode.WalkAway],
                                },
                            },
                        },
                    },
                },
            },
            then: {
                //  Additional fields in listing are mandatory when exceptionToListingFlag is false
                properties: {
                    listings: {
                        type: 'array',
                        items: listing_1.finalListingAdditionalMandatoryFieldsSchema,
                        minItems: 1,
                        isAfterFirstListingDate: ['appraisalDate', 'comparativeMarketAnalysisDate', 'date'],
                        isLessThanFirstListingAmount: ['revisedPriceAmount'],
                    },
                },
            },
        },
        {
            if: {
                required: ['assessment', 'detail'],
                properties: {
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                const: constants_2.ClaimTypeCode.DeficiencySale,
                            },
                        },
                    },
                },
            },
            then: {
                properties: {
                    assessment: __assign(__assign({}, assessment_1.assessmentSchema), { required: __spreadArrays(assessment_1.assessmentSchema.required, ['receivedDeficiencySaleClosingDate']) }),
                },
            },
        },
    ],
};
exports.validateFinalClaim = function (data) {
    var finalClaimValidator = new schema_validator_1.SchemaValidator(exports.finalClaimSchema, true, false, true, true);
    return finalClaimValidator.validate(data);
};
